import { ActionPane } from "components/layout/actionPane";
import { FormContentContainer } from "components/layout/formContentContainer";
import { CancelButton, SubmitButton } from "components/submitButton";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";

import { useUserSettings } from "./hooks/userSettingsContext";
import { UserSettings } from "./userSettings";
import { UserSettingsFields } from "./userSettingsFields";

export const UserSettingsForm = ({ onSuccess, onCancel }: Props) => {
  const { userSettings, setUserSettings } = useUserSettings();
  const form = useForm<UserSettings>({ values: userSettings });
  const { handleSubmit } = form;

  const onSubmit = (data: UserSettings) => {
    setUserSettings({ ...data, isMetric: data.isMetric.toString() === "true" });
    onSuccess();
  };

  return (
    <FormContentContainer>
      <FormProvider {...form}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <UserSettingsFields />
          <ActionPane>
            <SubmitButton>Save</SubmitButton>
            {!!onCancel && <CancelButton onClick={onCancel}>Cancel</CancelButton>}
          </ActionPane>
        </form>
      </FormProvider>
    </FormContentContainer>
  );
};

interface Props {
  readonly onSuccess?: () => void;
  readonly onCancel?: () => void;
}
